import React from "react";
import { Tooltip, IconButton, TableCell } from "@mui/material";
import { FaBalanceScale } from "react-icons/fa";

// Columna "Info": abre el modal de Auditoría Integral (antecedentes legales).
export default function CeldaInfo({ data, isError, handleOpenAuditoriaIntegral }) {
  return (
    <TableCell align="center">
      <Tooltip title="Ver antecedentes e información legal" arrow placement="top">
        <IconButton
          onClick={() => handleOpenAuditoriaIntegral(data)}
          size="medium"
          sx={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            background: isError
              ? "linear-gradient(135deg, #7f1d1d, #b91c1c)" // rojo sobrio
              : "linear-gradient(135deg, #334155, #64748b)", // gris azulado elegante
            color: "#f8fafc",
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            transition: "all 0.2s ease",
            "&:hover": {
              transform: "scale(1.08)",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            },
          }}
        >
          <FaBalanceScale size={18} />
        </IconButton>
      </Tooltip>
    </TableCell>
  );
}
